import { ButtonGroup, Dropdown, DropdownButton } from "react-bootstrap"
import { StoreCategoryModel } from "../../models"
import { useRef } from "react"
import { ucwords } from "../../helpers"

type Props = {
  categories: StoreCategoryModel[],
  onSelect: (categoryId: string) => void
}

const FloatingMenuButton: React.FC<Props> = ({categories, onSelect}) => {
  const nodeRef = useRef(null);

  return (
    <>
      <span 
        ref={nodeRef} 
        className="d-flex d-lg-none" 
        style={{position: "fixed", bottom: 80, right: 20, zIndex: 999}}>
        <DropdownButton
          className="floating-menu-button text-center"
          style={{
            border: "4px solid #fff",
            boxShadow: "1px 1px 10px #5d5d5d",
            borderRadius: "100%"
          }}
          as={ButtonGroup}
          drop="up"
          variant="success"
          title={
            <div className="d-flex flex-column align-items-center justify-content-center gap-1">
              {/* <List size={24} /> */}
              <svg viewBox="0 0 36 36" fill="#fff" width="24" height="24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M7 0c-3.314 0-6 3.134-6 7 0 3.31 1.969 6.083 4.616 6.812l-0.993 16.191c-0.067 1.098 0.778 1.996 1.878 1.996h1c1.1 0 1.945-0.898 1.878-1.996l-0.993-16.191c2.646-0.729 4.616-3.502 4.616-6.812 0-3.866-2.686-7-6-7zM27.167 0l-1.667 10h-1.25l-0.833-10h-0.833l-0.833 10h-1.25l-1.667-10h-0.833v13c0 0.552 0.448 1 1 1h2.604l-0.982 16.004c-0.067 1.098 0.778 1.996 1.878 1.996h1c1.1 0 1.945-0.898 1.878-1.996l-0.982-16.004h2.604c0.552 0 1-0.448 1-1v-13h-0.833z"/>
              </svg>
              {/* <span className="fw-bold text-white">Menu</span> */}
            </div>
          }
        >
          <div 
            style={{
              maxHeight: '400px',   // Set the maximum height for the dropdown
              overflowY: 'auto'     // Enable scrolling for long lists
            }}
          >
            {categories
              .filter((parentCategory) => parentCategory.parent_id == "0")
              .map((category) => (
              <Dropdown.Item 
                key={category.store_category_id} 
                as="button"
                onClick={() => onSelect(category.store_category_id)}
              >
                {ucwords(category.category_name)}
              </Dropdown.Item>
            ))}
          </div>
        </DropdownButton>
      </span>
    </>
  )
}

export default FloatingMenuButton